module.exports = __webpack_public_path__ + "images/control-box-bg.png";